import React from "react";
import { useMediaQuery } from "@mui/material";
import HomeWeb from "./HomeWeb";
import HomeMobile from "./HomeMobile";

const Home = () => {
  const isSmallScreen = useMediaQuery("(max-width:960px)");

  return isSmallScreen ? <HomeMobile /> : <HomeWeb />;
};

export default Home;
